<template>
  <span>
    <PapNavBar @hideSide="hideSide = $event" @attrSelected="attrSelected = $event"
      @returnClicked="returnClicked = $event" @flowChartTo="flowChartTo = $event" @openGoalSeek="openGoalSeek = $event"
      @openSensitivityAnalysis="openSensitivityAnalysis = $event" @editorMode="editorMode = $event"
      @executeSimulation="() => { isCalledByGoalSeek = false; taskSimulation++ }" :scenarioPeriod="periodSelect"
      @revisionPeriod="revisionPeriod = $event" @yearPeriod="yearPeriod = $event" :type="'PCP'"
      :updateInfoPCP="planCreated">
    </PapNavBar>

    <div class="collumns">
      <div class="collumnFlowChart" @mouseenter="hideSide">
        <Loading2 class="loading_productionPlan" :caption="this.$t('aguarde')"></Loading2>

        <PCP @sendInputList="callForSimulationBy($event)" :sendNodes="taskSimulation" :reloadNodes="objectStructure"
          :resetNodes="resetNodes" :flagEditMode="editorMode" :changeViewFlow="attrSelected" :flowchartTo="flowChartTo"
          :backFlowChart="returnClicked" />
      </div>

      <div class="collumnGrids">
        <div class="topSelect">
          <b-form-group label="" label-for="selectVar">
            <b-form-select id="selectVar" name="validateVar" class="inputData middle input-pentagro"
              v-model="periodSelect">
              <b-form-select-option :value="null" disabled>{{ $t('selecione-o-periodo') }}</b-form-select-option>
              <b-form-select-option v-for="item in period" :key="item.id" :value="item.description">{{ item.description
                }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </div>

        <div class="gridScroll">
          <GridInputPlan class="gridInput" :valorSelect="loadThisPeriod" :yearSelect="yearPeriod"
            :revisionSelect="loadRevisionPeriod" :updateTableEvent="simulationResult.table"
            @tableInput="tableInput = $event" :revisionSelected="this.loadRevisionPeriod" />
          <GridOutputPlan class="gridOutput" :valorSelect="loadThisPeriod" :yearSelect="yearPeriod"
            :revisionSelect="loadRevisionPeriod" :updateTableEvent="simulationResult.tableResult"
            @table="tableOutput = $event" />
        </div>

        <div class="groupBtn">
          <div class="footerButtons">
            <img :class="canExecute ? '' : 'disable-btn'" id="playSimulation" src="@/assets/play.png"
              :title="$t('executar-simulacao-ctrl-enter')" :alt="$t('executar-simulacao-ctrl-enter')" @click="() => {
                isCalledByGoalSeek = false
                taskSimulation++
              }" />
            <img id="saveSimulation"
              :class="showButtonSave && (this.loadRevisionPeriod && !this.loadRevisionPeriod.isBase) ? '' : 'disable-btn'"
              src="@/assets/salvar.png" :title="$t('salvar-alteracoes')" :alt="$t('salvar-planejamento')" @click="() => {
                this.$bvModal.show('confirmSaveProductionPlan')
              }" />
            <span :class="yearPeriod ? '' : 'disable-btn'">
              <img id="replanejarPlanoSafra" src="@/assets/replaned.png" :title="$t('replanejar-plano-de-safra')"
                :alt="$t('replanejar-plano-de-safra')" @click="() => {
                  this.$bvModal.show('replanedProductionPlan')
                }" />
              <img
                :class="(this.loadRevisionPeriod && !this.loadRevisionPeriod.isBase && this.hasImportXml == true) ? '' : 'disable-btn'"
                id="importarCenario" src="@/assets/importar.png" :title="$t('importar-cenario')"
                :alt="$t('importar-cenario')" @click="() => {
                  this.$bvModal.show('importscenario')
                }" />
              <img id="updateVariables" src="@/assets/atualizar.png" :title="$t('atualizar-variaveis-de-saida')"
                :alt="$t('atualizar-variaveis')" @click="updateTables()" />
            </span>
          </div>
        </div>
      </div>
      <slot />
      <b-modal id="resultSimulation" size="lg" hide-footer :title="$t('simulacao-em-execucao')"
        :no-close-on-backdrop="true">
        <SimulatorResult :result="result" @resultado="calculate($event)"
          @closeSimulatiorResult="closeSimulatiorResult()" @stopSimulation="stopSimulation()">
        </SimulatorResult>
      </b-modal>
      <b-modal id="goalSeek" size="xl" hide-footer :title="$t('atingir-metas')" :no-close-on-backdrop="true">
        <GoalSeek :table="tableInput" :tableResultGoal="tableOutput" @loadTableOutputGoal="loadTableOutput = $event"
          nameModel="goalSeek"></GoalSeek>
      </b-modal>
      <b-modal id="importscenario" size="md" hide-footer :title="'Importar Cenário para o Periodo'"
        :no-close-on-backdrop="true">
        <ImportScenarioToPeriod :periodId="periodObj.id" :planRevision="revisionPeriod" @signal="receive($event)" />
      </b-modal>
      <b-modal id="replanedProductionPlan" size="md" hide-footer :title="'Criar Nova Revisão'"
        :no-close-on-backdrop="true">
        <createNewProductionPlanReplaned :planReplaned="test" @teste="planCreated = $event" />
      </b-modal>
      <b-modal id="confirmSaveProductionPlan" size="md" hide-footer :title="$t('salvar-planejamento')"
        :no-close-on-backdrop="true">
        <MessageBox :question="msgConfirmProductionPlan" modelname="confirmSaveProductionPlan"
          :action="saveSimulator" />
      </b-modal>
    </div>
  </span>
</template>

<script>
import { hideSide } from "../flowchart/utils/showAndHideSide"
import { SingletonAreas } from "../flowchart/nodes/_service/singletonAreas";
import GridInputPlan from "../template/GridInputPlan";
import GridOutputPlan from "../template/GridOutputPlan";
import SimulatorResult from "./SimulatorResult.vue"
import GoalSeek from '../goalSeek/GoalSeek';
import PCP from '../flowchart/PCP.vue'
import PapNavBar from "../pap/papNavBar.vue"
import Validators from "../flowchart/nodes/_service/singletonTools/validators";
import GetNameFromXml from "../scenario/getNameFromXml"
import ImportScenarioToPeriod from "./ImportScenarioToPeriod.vue"
import createNewProductionPlanReplaned from "./CreateNewProductionPlanReplaned"
import MessageBox from '../template/MessageBoxModal.vue';

import { PapMixin } from "../flowchart/utils/papMixin"
import { mapState } from "vuex";

import { urlMainAPI, showError, defaultSuccess } from "@/global";

import axios from "axios";
const CancelToken = axios.CancelToken;
let executeRequest = CancelToken.source();
const refreshToken = (() => {
  executeRequest = CancelToken.source();
});
import Loading2 from "../template/Loading2.vue";

export default {
  name: "ProductionPlanCreatorEditor",

  components: { PCP, GridInputPlan, GridOutputPlan, SimulatorResult, GoalSeek, Loading2, PapNavBar, ImportScenarioToPeriod, createNewProductionPlanReplaned, MessageBox },

  computed: mapState(["user"]),

  mixins: [PapMixin],

  provide() {
    return {
      getTablesToGoalSeek: this.getTablesInput,
      callCalculationSimulation: this.calculate,
      setStopSimulation: { stopStimulation: this.stopSimulation, executeRequest: executeRequest, refreshToken: refreshToken },
      stateOfSimulation: this.stateOfSimulation,
      startSimulation: this.simulationByShortcut,
      showLoading: this.showLoading
    }
  },

  data() {
    return {
      canExecute: false,
      simulationResult: {
        table: null,
        tableResult: null
      },
      isCalledByGoalSeek: false,
      taskSimulation: 0,
      resetNodes: 0,
      callReloadNodes: 0,
      showButtonSave: false,
      onSimulation: false,
      objectStructure: {},
      tableFlowChart: null,
      loadTableOutput: null,
      resultCalcOBJ: null,
      tableInput: [],
      tableOutput: [],
      tableResult: [],
      period: [],
      comboPeriod: [],
      periodSelect: null,
      yearPeriod: null,
      revisionPeriod: null,
      loadThisPeriod: 0,
      result: [],
      xml: {},
      hideSide: hideSide,
      attrSelected: null,
      returnClicked: 0,
      flowChartTo: "",
      openGoalSeek: 0,
      openSensitivityAnalysis: 0,
      editorMode: false,
      periodObj: 0,
      data: 0,
      loadRevisionPeriod: null,
      planCreated: null,
      msgConfirmProductionPlan: "",
      hasImportXml: false,
    }
  },

  watch: {
    async data() {
      await this.getFlowChartPeriod(this.yearPeriod, this.loadThisPeriod, this.loadRevisionPeriod);
    },

    async periodSelect(namePeriod) {
      this.showLoading(true);
      this.loadThisPeriod = namePeriod
      this.periodObj = this.period.filter(p => p.description == namePeriod).reduce(p => p)
      if (this.yearPeriod != null && this.loadRevisionPeriod) {
        await this.getFlowChartPeriod(this.yearPeriod, this.loadThisPeriod, this.loadRevisionPeriod)
        if (this.xml) {
          this.xml.period = this.loadThisPeriod
          localStorage.setItem("xml", JSON.stringify(this.xml));
          localStorage.setItem("xmlPeriod", this.xml.period);
        }
      }
      this.showLoading(false);
    },

    async revisionPeriod(revision) {
      this.canExecute = false
      this.showLoading(true);
      this.loadRevisionPeriod = revision;
      await this.getFlowChartPeriod(this.yearPeriod, this.loadThisPeriod, this.loadRevisionPeriod)
      if (this.xml) {
        this.xml.period = this.loadThisPeriod
        localStorage.setItem("xml", JSON.stringify(this.xml));
        localStorage.setItem("xmlPeriod", this.xml.period);
      }

      this.msgConfirmProductionPlan = `Deseja realmente salvar na revisão (${revision.description})?`;
      this.showButtonSave = true
      this.planCreated = null
    },
  },

  methods: {
    test() {
      this.tableInput.forEach(x => { if (x.value) x.value = String(x.value) })
      let zeroedValues = 0
      this.tableInput.forEach(item => { item.value == 0 ? zeroedValues++ : 0 })

      if (this.revisionPeriod) {
        let planReplaned = {
          planId: this.revisionPeriod.id,
          baseYear: this.yearPeriod,
          periodId: this.periodObj.id,
          description: "",
          revision: this.revisionPeriod.versionNumber,
          table: this.tableInput,
          table2: this.tableOutput
        }
        return planReplaned
      }
    },

    async loadSelectPeriod() {
      const url = `${urlMainAPI}/getproductionplanperiod`;
      await axios
        .get(url)
        .then((res) => {
          this.period = res.data;
        })
        .catch();
    },

    async receive(data) {
      this.data = data
    },

    changeEditMode() {
      this.editorMode = !this.editorMode
    },

    async calculate(obj) {
      this.showLoading(true)
      if (!obj) {
        obj = {
          scenario: this.result.scenario,
          scenarioResult: this.result.scenarioResult,
          inputMapping: null,
          table: this.tableInput.map((x) => { return { id: x.id, item: x.item, root: x.root, value: String(x.value) } }),
          tableResult: this.tableOutput
        }
      }

      let that = this
      const url = `${urlMainAPI}/calculateproductionplansimulationresult`
      await axios
        .post(url, obj)
        .then((res) => {
          this.resultCalcOBJ = res.data

          this.xml.scenario = this.resultCalcOBJ.scenario
          this.xml.scenarioResult = this.resultCalcOBJ.scenarioResult
          this.xml.scenarioObjectStructure = res.data.scenarioObjectStructure
          this.objectStructure = res.data.scenarioObjectStructure
          this.objectStructure.callReload = ++this.callReloadNodes;

          this.$store.commit("setXML", this.xml);
          localStorage.setItem("xml", JSON.stringify(this.xml));

          this.showButtonSave = true
          defaultSuccess(this.$t('calculando-dados'))
        })
        .catch(function (e) {
          console.log(e)
          that.showLoading(false)
        });


      this.tableInput = this.resultCalcOBJ.table;
      this.tableOutput = this.resultCalcOBJ.tableResult;
      this.simulationResult = { table: this.tableInput, tableResult: this.tableOutput }
      this.isCalledByGoalSeek = false;
    },

    callForSimulationBy(listOfInputNodes) {
      this.tableFlowChart = listOfInputNodes
      if (!this.isCalledByGoalSeek) {
        this.executeSimulation(listOfInputNodes);
      }
      else {
        this.$bvModal.show('goalSeek')
      }
    },

    getTablesInput() {
      let tableInputs = this.tableInput.map(x => ({ id: x.id, item: x.item, value: String(x.value) }));
      return ({ tableFlowChart: this.tableFlowChart, table: tableInputs });
    },

    haveAllEntries() {
      let zeroedValues = 0
      let qty = 0
      this.tableInput.forEach(item => {
        item.value == 0 ? zeroedValues++ : zeroedValues
        item.root == "false" ? qty++ : qty
      })
      return zeroedValues == qty
    },

    async updateTables() {
      this.tableInput.forEach(x => { if (x.value) x.value = String(x.value) })
      let zeroedValues = 0
      this.tableInput.forEach(item => { item.value == 0 ? zeroedValues++ : 0 })

      let xml = JSON.parse(localStorage.xml);
      let objectStructure = JSON.stringify(xml.scenarioObjectStructure);

      let obj = {
        inputMapping: null,
        table: this.tableInput,
        tableResult: this.tableOutput,
        objectStructure: objectStructure
      }

      let that = this
      const url = `${urlMainAPI}/calculateproductionplansimulationresult`
      await axios
        .post(url, obj)
        .then((res) => {
          this.resultCalcOBJ = res.data
          this.showButtonSave = true
          this.canExecute = true
        })
        .catch(function (e) {
          console.log(e)
          that.showLoading(false)
        });

      this.tableInput = this.resultCalcOBJ.table;
      this.tableOutput = this.resultCalcOBJ.tableResult;
      this.simulationResult = { table: this.tableInput, tableResult: this.tableOutput }
      this.isCalledByGoalSeek = false;
    },

    async executeSimulation() {
      defaultSuccess(this.$t('iniciando-simulacao'));

      let obj = {
        scenario: this.xml.scenario,
        inputMapping: null,
        table: this.tableInput.map((x) => { return { id: x.id, item: x.item, value: String(x.value) } }),
        tableFlowChart: this.tableFlowChart
      }
      Validators.readOnly = this.readOnly

      obj.tableFlowChart = Validators.CheckProblemsInEnginneringMapping(obj.tableFlowChart)

      const url = `${urlMainAPI}/executeproductionplansimulation`

      const maxRetries = 3;
      let result = null;
      let lastError = null;

      this.$bvModal.show('resultSimulation')
      this.stateOfSimulation(true)
      const startCountTime = Date.now()

      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          result = await axios.post(url, obj, { cancelToken: executeRequest.token });

          const errorText = (result.data && result.data.error) ? result.data.error : '';
          const isPipeBroken = errorText.toLowerCase().includes('pipe') || errorText.toLowerCase().includes('broken');

          if (isPipeBroken && attempt < maxRetries) {
            console.warn(`[Simulação] Pipe broken na tentativa ${attempt}/${maxRetries}, retentando...`);
            this.$bvToast.toast(`Tentativa ${attempt}/${maxRetries} falhou (pipe). Retentando...`, {
              title: 'Simulação',
              variant: 'warning',
              toaster: 'b-toaster-bottom-left',
              solid: true,
              autoHideDelay: 2000
            });
            await new Promise(resolve => setTimeout(resolve, 1000));
            continue;
          }

          lastError = null;
          break;
        } catch (e) {
          if (axios.isCancel(e)) {
            lastError = e;
            break;
          }

          lastError = e;
          const detail = e.response?.data?.detail || e.response?.data?.error || e.message || '';
          const isPipeBroken = detail.toLowerCase().includes('pipe') || detail.toLowerCase().includes('broken');

          if (isPipeBroken && attempt < maxRetries) {
            console.warn(`[Simulação] Pipe broken (exceção) na tentativa ${attempt}/${maxRetries}, retentando...`);
            this.$bvToast.toast(`Tentativa ${attempt}/${maxRetries} falhou (pipe). Retentando...`, {
              title: 'Simulação',
              variant: 'warning',
              toaster: 'b-toaster-bottom-left',
              solid: true,
              autoHideDelay: 2000
            });
            await new Promise(resolve => setTimeout(resolve, 1000));
            continue;
          }

          break;
        }
      }

      if (lastError) {
        this.$bvModal.hide('resultSimulation')
      } else if (result) {
        const endCountTime = Date.now()
        this.result = result.data;
        this.result.simulationTimeFront = (endCountTime - startCountTime) / 1000
      }

      this.stateOfSimulation(false)
      this.isCalledByGoalSeek = false
    },

    stopSimulation() {
      executeRequest.cancel(this.$t('cancelamento-executado-com-sucesso'))
      refreshToken()
      const url = `${urlMainAPI}/stopsimulation`
      axios
        .get(url)
        .then(showError(this.$t('simulacao-cancelada')))
        .catch()
      refreshToken()
    },

    saveSimulator() {
      let obj = {};

      obj.baseYear = parseInt(this.yearPeriod)
      obj.planId = this.planCreated ? this.planCreated.planId : this.revisionPeriod.id;
      obj.versionnumber = this.planCreated ? this.planCreated.revision : this.revisionPeriod.versionNumber

      obj.inputs = this.tableInput.map((x) => {
        return { id: x.id, item: x.item, value: x.value == null ? "" : x.value.replace('.', ',') }
      });

      for (let i = 0; i < this.period.length; i++) {
        if (this.period[i].description == this.periodSelect) {
          obj.periodId = parseInt(this.period[i].id)
        }
      }

      this.saveFlowChartPeriod(obj.periodId)

      obj.outputs = this.tableOutput.map((x) => {
        return { id: x.id, item: x.item, value: x.value == null ? "" : x.value.replace('.', ',') }
      });

      const url = `${urlMainAPI}/saveproductionplanperioddata`
      axios.post(url, obj).then((res) => {
        defaultSuccess(res.data);
      }).catch((e) => {
        showError(e);
        console.log("Falha ao salvar o plano de safra: ", e)
      });
      this.xml.name = `${this.revisionPeriod.description}-${this.periodSelect}`;

      localStorage.setItem("xml", JSON.stringify(this.xml));
      this.$store.commit("setScenarioName", `${this.revisionPeriod.description}-${this.periodSelect}`);

      this.hasImportXml = true;
    },

    saveFlowChartPeriod(idPeriod) {
      let xmlLocal = localStorage.xml ? JSON.parse(localStorage.xml) : ''
      if (xmlLocal && xmlLocal.scenarioObjectStructure) {
        this.objectStructure = xmlLocal.scenarioObjectStructure
      }

      let obj = {
        planId: this.planCreated ? this.planCreated.planId : this.revisionPeriod.id,
        productionUnitId: 0,
        periodId: idPeriod,
        objectStructure: this.objectStructure != "{}" ? JSON.stringify(this.objectStructure) : "",
        revision: "",
        xmlScenario: this.result.scenario == null ? xmlLocal.scenario : this.result.scenario,
        versionnumber: this.planCreated ? this.planCreated.revision : this.revisionPeriod.versionNumber
      }

      if (!obj.objectStructure) return

      const url = `${urlMainAPI}/saveproductionplanperiodflowchart`
      axios.post(url, obj).then(() => {
      }).catch(e => console.log(`Falha ao salvar o diagrama do mes ${idPeriod}: `, e));
    },

    async getFlowChartPeriod(year, period, revision) {
      const objPeriod = this.period.filter(p => p.description == period).reduce(p => p)
      const url = `${urlMainAPI}/getProductionPlanPeriodFlowchart/${year}/${revision.id}/${revision.versionNumber}/${objPeriod.id}`
      let xmlModify = {};

      await axios.get(url).then(async (res) => {
        if (res.data == null || res.data == "") {
          await this.loadActiveScenario("PADRAO");
          xmlModify = JSON.parse(localStorage.xml);
          let obj = JSON.parse(localStorage.xml)
          this.objectStructure = obj.scenarioObjectStructure;
          xmlModify.scenarioObjectStructure = this.objectStructure;
          xmlModify.scenario = obj.scenario == null ? JSON.parse(localStorage.bckpXML) : obj.scenario;
          xmlModify.scenarioResult = obj.scenarioResult
          xmlModify.name = obj.name
          xmlModify.nameXml = obj.nameXml
          this.xml = xmlModify;

          this.$store.commit("setXML", this.xml);
          this.$store.commit("setScenarioName", this.xml.name);
          localStorage.setItem("xml", JSON.stringify(this.xml));
          this.hasImportXml = false
          defaultSuccess(`Cenário Carregado: ${this.xml.name}`)
        } else if (res.data.objectStructure !== null) {
          this.objectStructure = JSON.parse(res.data.objectStructure);
          xmlModify.scenarioObjectStructure = this.objectStructure
          xmlModify.name = `${this.revisionPeriod.description}-${this.periodSelect}`
          xmlModify.nameXml = GetNameFromXml(JSON.stringify(res.data.xmlScenario))
          xmlModify.period = this.periodSelect
          xmlModify.scenario = res.data.xmlScenario == null || res.data.xmlScenario == "" ? JSON.parse(localStorage.bckpXML) : res.data.xmlScenario;
          this.xml = xmlModify;
          this.$store.commit("setXML", this.xml);
          this.$store.commit("setScenarioName", this.xml.name);
          localStorage.setItem("xml", JSON.stringify(this.xml));

          if (res.data.xmlScenario != null && res.data.xmlScenario != "") {
            this.hasImportXml = true
            defaultSuccess(`Cenário Carregado: ${period}`)
          } else {
            this.hasImportXml = false
            defaultSuccess(`Cenário Carregado: ${this.xml.name}`)
          }
        }
      }).catch(e => {
        console.log(`Falha obter o flowchart do production plan ${objPeriod.id}: `, e)
        this.resetNodes++
        this.showButtonSave = false
      });
      this.showLoading(false);
    },

    showLoading(show) {
      if (show)
        document.querySelector('.loading_productionPlan').style.display = 'flex';
      else
        document.querySelector('.loading_productionPlan').style.display = 'none';
    },

    simulationByShortcut() {
      this.taskSimulation++
    },

    stateOfSimulation(isSimulating) {
      if (isSimulating === 'state') {
        return this.onSimulation
      }
      this.onSimulation = isSimulating
      return this.onSimulation
    },

    async loadActiveScenario(name) {
      let obj = {};
      obj.name = name == undefined ? localStorage.getItem("lastScenarioName") : name;
      const url = `${urlMainAPI}/loadsimulationscenario`;
      await axios.post(url, obj).then((res) => {
        let xml = {};
        xml.name = res.data.name;
        xml.nameXml = GetNameFromXml(JSON.stringify(res.data.scenario))
        xml.scenario = res.data.scenario;
        xml.scenarioResult = res.data.scenarioResult;
        xml.scenarioObjectStructure = res.data.scenarioObjectStructure;

        let oldXml = GetNameFromXml(localStorage.xml)
        let IsDiferent = oldXml != xml.nameXml
        SingletonAreas.LoadScenario(res.data.scenarioObjectStructure, IsDiferent)

        this.$store.commit("setXML", xml);
        localStorage.setItem("xml", JSON.stringify(xml));
        this.$store.commit("setScenarioName", xml.name);

        this.selection = "";
      });
    },
  },

  async created() {
    this.xml = this.$store.state.xml;
    await this.loadSelectPeriod();
    let xml = localStorage.xml ? JSON.parse(localStorage.xml) : {}
    let bckpScenario = xml.scenario == null || xml.scenario == undefined ? "" : xml.scenario;
    localStorage.setItem("bckpXML", JSON.stringify(bckpScenario));
    if (xml.period) {
      this.periodSelect = xml.period
    } else {
      this.periodSelect = document.querySelectorAll("#selectVar>option")[1].value;
    }
  },

  async beforeDestroy() {
    await this.loadActiveScenario();
  }
}
</script>

<style scoped>
.loading_productionPlan {
  display: none;
  align-items: center;
  position: fixed;
  top: 40%;
  left: 40%;
  height: 7%;
  width: 15%;
  min-width: 180px;
  min-height: 50px;
  z-index: 5;
  box-shadow: 3px 2px 15px black;
  background-color: rgba(255, 255, 255, 0.959);
}

.collumns {
  margin-top: 5px;
  display: grid;
  grid-template-columns: 1fr 360px;
  width: 100%;
  height: 100%;
}

.collumnFlowChart {
  display: block;
  grid-column-start: 1;
  transition-duration: 0.3s;
  height: max-content;
}

.collumnGrids {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border: 1px solid #0008;
  border-radius: 5px;
  box-shadow: 0px 0px 3px #0008;
  width: 100%;
  height: max-content;
}

.gridScroll {
  height: 58vh;
  width: 100%;
  overflow: hidden;
}

.topSelect {
  display: grid;
  grid-row-start: 1;
  align-content: center;
}

.expand {
  position: absolute;
  top: 25px;
  right: 25px;
  border-radius: 5px;
  height: 40px;
}

#selectVar {
  width: 280px;
}

#loading {
  top: calc(50% + -100px);
  left: calc(50% + -224px);
}

.gridInput {
  width: 100%;
  height: 31vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.gridOutput {
  width: 100%;
  height: 31vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.groupBtn {
  margin-top: auto;
  border-top: 2px solid gray;
  margin-right: 10px;
}

.inputData {
  display: grid;
  margin: auto;
}

.imgData {
  width: 45px;
}

.footerButtons {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-around;
  grid-row-start: 4;
  margin-top: 10px;
}

.footerButtons img {
  justify-content: flex-end;
  cursor: pointer;
  margin-left: 30px;
  max-height: 35px;
}

.imgPAP {
  height: 100%;
  width: 100%;
}

.disable-btn,
.disable-btn img {
  filter: grayscale(1);
  pointer-events: none;
  user-select: none;
  cursor: not-allowed;
}

@media (max-width: 1600px) {
  .gridScroll {
    height: 57vh;
  }
}

@media (max-width: 1366px) {
  .collumnGrids {
    height: 60vh;
  }
}

@media (max-height: 760px) {
  .gridScroll {
    height: 48vh;
  }
}

@media (max-width: 1310px) {
  .collumnGrids {
    height: 67vh;
  }
}

@media (min-width: 1800px) {
  .collumnGrids {
    height: 71vh;
  }
}

@media (max-width: 835px) {

  #expand,
  #collpse {
    display: none;
  }

  .gridScroll {
    width: 100%;
  }

  .collumns {
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
  }

  .collumnGrids {
    margin: 15px 0px;
    grid-template-rows: 50px 3fr .5fr;
    grid-template-columns: 1fr 1fr;
    grid-column-start: 1;
    grid-row-start: 2;
    justify-content: start;
    width: 100%;
    height: 60vh;
  }

  .topSelect {
    justify-self: center;
    width: 394px;
    grid-column-start: 1;
  }

  .gridInput {
    grid-column-start: 1;
    grid-row-start: 2;
    margin: 0px 10px;
  }

  .gridOutput {
    grid-column-start: 2;
    grid-row-start: 2;
    margin: 0px 10px;
  }

  .groupBtn {
    margin-top: 10px;
    grid-column-end: span 2;
    grid-row-start: 3;
  }
}
</style>